module.exports = __webpack_public_path__ + "static/media/hjarte.c56db58b.mp3";